import React, { useRef } from 'react';
var VeltInlineCommentsSectionSortingDropdownContentItemTick = function (props) {
    var defaultCondition = props.defaultCondition, targetElementId = props.targetElementId, type = props.type, sortOption = props.sortOption, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-inline-comments-section-sorting-dropdown-content-item-tick", { ref: ref, "target-element-id": targetElementId, type: type, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined, "sort-option": sortOption }, children));
};
export default VeltInlineCommentsSectionSortingDropdownContentItemTick;
